module.exports = __webpack_public_path__ + "img/0xa8c2b8eec3d368c0253ad3dae65a5f2bbb89c929.e3eb983f.png";